import { Outlet, ScrollRestoration } from 'react-router-dom'

export function AppLayout() {
  return (
    <div className="flex min-h-screen flex-col bg-background text-foreground">
      <ScrollRestoration />
      <Outlet />
    </div>
  )
}